import { PropsWithChildren, createContext, useContext } from 'react';
import { IRouter } from './react-router';

const RouterContext = createContext<IRouter | undefined>(undefined);

export function useRouter(): IRouter {
  const router = useContext(RouterContext);
  if (!router) {
    throw new Error('<RouterProvider> needs to exist in component ancestry');
  }
  return router;
}

export type RouterProviderProps = {
  readonly router: IRouter;
};

export const RouterProvider = (
  props: PropsWithChildren<RouterProviderProps>
) => {
  const { children } = props;
  return (
    <RouterContext.Provider value={props.router}>
      {children}
    </RouterContext.Provider>
  );
};
